import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import { hit } from '../../metrics';
import HelmetSite from '../HelmetSite';
import CaseFooterNew from '../CaseFooterNew';
import './style.css';

const copy = {
  title: '\u0416\u0438\u043b\u043e\u0439 \u043a\u043e\u043c\u043f\u043b\u0435\u043a\u0441 \u201c\u0414\u043e\u043c \u041a\u0438\u043d\u043e\u201d',
  client: '\u041f\u0435\u0440\u0432\u044b\u0439 \u0414\u0435\u0432\u0435\u043b\u043e\u043f\u0435\u0440',
  services: '\u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0431\u0440\u0435\u043d\u0434\u0430\u00a0\u00a0\u00a0\u0424\u0438\u0440\u043c\u0435\u043d\u043d\u044b\u0439 \u0441\u0442\u0438\u043b\u044c',
  about: '\u00ab\u0414\u043e\u043c \u041a\u0438\u043d\u043e\u00bb \u043d\u0430\u0445\u043e\u0434\u0438\u0442\u0441\u044f \u0432 \u0434\u0432\u0443\u0445 \u0448\u0430\u0433\u0430\u0445 \u043e\u0442 \u043a\u0438\u043d\u043e\u0442\u0435\u0430\u0442\u0440\u0430, \u043f\u043e\u0434\u0430\u0440\u0438\u0432\u0448\u0435\u0433\u043e \u0435\u043c\u0443 \u0438\u043c\u044f, \u2014 \u0432 \u0441\u0430\u043c\u043e\u043c \u0446\u0435\u043d\u0442\u0440\u0435 \u041c\u043e\u0441\u043a\u0432\u044b. \u041c\u044b \u0440\u0430\u0437\u0440\u0430\u0431\u043e\u0442\u0430\u043b\u0438 \u0434\u043b\u044f \u044d\u0442\u043e\u0433\u043e \u0430\u0434\u0440\u0435\u0441\u0430 \u0431\u0440\u0435\u043d\u0434-\u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0443 \u0438 \u043b\u043e\u0433\u043e\u0442\u0438\u043f, \u0430 \u0432 \u043e\u0441\u043d\u043e\u0432\u0443 \u0431\u0440\u0435\u043d\u0434\u0430 \u043b\u0435\u0433\u043b\u0430 \u0438\u0434\u0435\u044f \u0442\u0438\u0445\u043e\u0439 \u043f\u0440\u0438\u0432\u0438\u043b\u0435\u0433\u0438\u0438: \u0436\u0438\u0442\u044c \u0432 \u0441\u0435\u0440\u0434\u0446\u0435 \u0433\u043e\u0440\u043e\u0434\u0430, \u043d\u0438\u043a\u043e\u043c\u0443 \u044d\u0442\u043e\u0433\u043e \u043d\u0435 \u0434\u043e\u043a\u0430\u0437\u044b\u0432\u0430\u044f.',
  positioning: '\u041f\u043e\u0437\u0438\u0446\u0438\u043e\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u0431\u043e\u043b\u044c\u0448\u0438\u043d\u0441\u0442\u0432\u0430 \u043f\u0440\u043e\u0435\u043a\u0442\u043e\u0432 \u0432 \u0446\u0435\u043d\u0442\u0440\u0435 \u041c\u043e\u0441\u043a\u0432\u044b \u0441\u0442\u0440\u043e\u0438\u0442\u0441\u044f \u043d\u0430 \u043c\u0430\u0441\u0448\u0442\u0430\u0431\u0435 \u0438 \u0432\u044b\u0440\u0430\u0437\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u0438 \u0430\u0440\u0445\u0438\u0442\u0435\u043a\u0442\u0443\u0440\u044b. \u041f\u0440\u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043e\u0442\u043a\u0435 \u0431\u0440\u0435\u043d\u0434-\u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u044b \u043c\u044b \u043f\u0440\u0435\u0434\u043b\u043e\u0436\u0438\u043b\u0438 \u0434\u0440\u0443\u0433\u0443\u044e \u043e\u043f\u043e\u0440\u0443 \u0434\u043b\u044f \u0431\u0440\u0435\u043d\u0434\u0430: \u043e\u0449\u0443\u0449\u0435\u043d\u0438\u0435, \u0447\u0442\u043e \u0436\u0438\u0437\u043d\u044c \u0432 \u0441\u0430\u043c\u043e\u043c \u0441\u0435\u0440\u0434\u0446\u0435 \u0441\u0442\u043e\u043b\u0438\u0446\u044b \u043c\u043e\u0436\u0435\u0442 \u0431\u044b\u0442\u044c \u043f\u0440\u043e\u0441\u0442\u043e \u043d\u043e\u0440\u043c\u043e\u0439 \u2014 \u0431\u0435\u0437 \u043b\u0438\u0448\u043d\u0438\u0445 \u0443\u0441\u0438\u043b\u0438\u0439 \u0438 \u0434\u043e\u043a\u0430\u0437\u0430\u0442\u0435\u043b\u044c\u0441\u0442\u0432. \u0422\u0430\u043a \u0440\u043e\u0434\u0438\u043b\u043e\u0441\u044c \u043f\u043e\u0437\u0438\u0446\u0438\u043e\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u00ab\u0414\u043e\u043c \u041a\u0438\u043d\u043e\u00bb \u2014 \u0442\u0440\u043e\u0444\u0435\u0439\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441, \u0432\u044b\u0431\u0440\u0430\u043d\u043d\u044b\u0439 \u043e\u0441\u043e\u0437\u043d\u0430\u043d\u043d\u043e.',
  sign: '\u0417\u043d\u0430\u043a \u043f\u0440\u043e\u0434\u043e\u043b\u0436\u0430\u0435\u0442 \u0430\u0440\u0445\u0438\u0442\u0435\u043a\u0442\u0443\u0440\u0443 \u0434\u043e\u043c\u0430: \u0431\u0430\u0448\u043d\u044f \u043f\u0440\u0435\u0432\u0440\u0430\u0449\u0430\u0435\u0442\u0441\u044f \u0432 \u0432\u0435\u0440\u0442\u0438\u043a\u0430\u043b\u044c\u043d\u044b\u0435 \u043b\u0438\u043d\u0438\u0438, \u0442\u044f\u043d\u0443\u0449\u0438\u0435\u0441\u044f \u0432\u0432\u0435\u0440\u0445 \u0432 \u0442\u0430\u043a\u0442 \u0444\u0430\u0441\u0430\u0434\u0443, \u0430 \u0443 \u0438\u0445 \u043f\u043e\u0434\u043d\u043e\u0436\u0438\u044f \u043f\u0440\u043e\u0441\u0442\u0443\u043f\u0430\u0435\u0442 \u0441\u0438\u043b\u0443\u044d\u0442 \u0438\u0441\u0442\u043e\u0440\u0438\u0447\u0435\u0441\u043a\u043e\u0433\u043e \u0414\u043e\u043c\u0430 \u041a\u0438\u043d\u043e \u2014 \u0442\u0430\u043a \u043a\u043e\u0440\u043e\u0442\u043a\u0430\u044f \u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u0434\u0435\u0442\u0430\u043b\u044c \u0441\u0432\u044f\u0437\u044b\u0432\u0430\u0435\u0442 \u0434\u0432\u0435 \u044d\u043f\u043e\u0445\u0438 \u043e\u0434\u043d\u043e\u0433\u043e \u043c\u0435\u0441\u0442\u0430.',
  logo: '\u0428\u0440\u0438\u0444\u0442 \u043b\u043e\u0433\u043e\u0442\u0438\u043f\u0430 \u2014 \u043f\u043b\u043e\u0442\u043d\u044b\u0439 \u0438 \u0441\u0442\u0440\u0435\u043c\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439, \u0441 \u043e\u0449\u0443\u0442\u0438\u043c\u044b\u043c \u0432\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u0438\u043c \u0440\u0438\u0442\u043c\u043e\u043c: \u0431\u0443\u043a\u0432\u044b \u0431\u0443\u0434\u0442\u043e \u0432\u044b\u0442\u044f\u043d\u0443\u0442\u044b \u0432\u0432\u0435\u0440\u0445, \u0432\u0441\u043b\u0435\u0434 \u0437\u0430 \u0441\u0430\u043c\u0438\u043c \u0437\u0434\u0430\u043d\u0438\u0435\u043c. \u042d\u0442\u0430 \u0433\u0440\u0430\u0444\u0438\u043a\u0430 \u0434\u0435\u0440\u0436\u0438\u0442 \u0445\u0430\u0440\u0430\u043a\u0442\u0435\u0440 \u0431\u0440\u0435\u043d\u0434\u0430 \u0432 \u043b\u044e\u0431\u043e\u043c \u043c\u0430\u0441\u0448\u0442\u0430\u0431\u0435 \u2014 \u043e\u0442 \u0433\u0440\u0430\u0432\u0438\u0440\u043e\u0432\u043a\u0438 \u043d\u0430 \u0432\u0445\u043e\u0434\u043d\u043e\u0439 \u0433\u0440\u0443\u043f\u043f\u0435 \u0434\u043e \u043d\u0435\u043e\u043d\u043e\u0432\u043e\u0439 \u0432\u044b\u0432\u0435\u0441\u043a\u0438 \u0432\u0435\u0447\u0435\u0440\u043e\u043c.'
};

const fixPrepositions = value => value.replace(
  /(^|[\s(])((?:\u0431\u0435\u0437|\u0434\u043b\u044f|\u043f\u0440\u0438|\u043d\u0430\u0434|\u043f\u043e\u0434|\u0432\u043e|\u0434\u043e|\u0437\u0430|\u0438\u0437|\u043d\u0430|\u043e\u0442|\u043f\u043e|\u0430|\u0432|\u0438|\u043a|\u043e|\u0441|\u0443))\s+/gi,
  (match, prefix, preposition) => `${prefix}${preposition}\u00a0`
);

const CopySection = ({ title, children }) => (
  <section className="domkino-copy domkino-section">
    <h2>{fixPrepositions(title)}</h2>
    <p>{fixPrepositions(children)}</p>
  </section>
);

const Poster = ({ name, alt }) => (
  <section className="domkino-poster domkino-section">
    <img src={`/cases/img/domkino/${name}.webp`} alt={alt} loading="lazy" />
  </section>
);

class Domkino extends Component {
  componentDidMount() {
    if (
      this.props.pathname === '/projects/domkino/' ||
      this.props.pathname === '/projects/domkino' ||
      this.props.pathname === '/projects/dom-kino/' ||
      this.props.pathname === '/projects/dom-kino'
    ) {
      this.props.setProjectName('domkino');
      $('body').addClass('case-expanded hash-domkino');
      this.props.changeCase(null);
    }

    window.scrollTo(0, 0);
    hit(window.location.pathname);

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (window.gsap && window.ScrollTrigger && !reduceMotion) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      const imageTweens = window.gsap.utils.toArray('#case-domkino .domkino-parallax').map((image, index) => (
        window.gsap.fromTo(
          image,
          { yPercent: index % 2 ? -4 : 4, scale: 1.08 },
          {
            yPercent: index % 2 ? 4 : -4,
            scale: 1.08,
            ease: 'none',
            scrollTrigger: {
              trigger: image.closest('section') || image.parentElement,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1.2
            }
          }
        )
      ));
      const backgroundTweens = window.gsap.utils.toArray('#case-domkino .domkino-parallax-bg').map(background => (
        window.gsap.fromTo(
          background,
          { yPercent: -5, scale: 1.13 },
          {
            yPercent: 5,
            scale: 1.13,
            ease: 'none',
            scrollTrigger: {
              trigger: background.parentElement,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1.4
            }
          }
        )
      ));
      this.motionTweens = imageTweens.concat(backgroundTweens);
    }

    this.fadeTimer = window.setTimeout(() => $('body').addClass('fadepage'), 120);
  }

  componentWillUnmount() {
    window.clearTimeout(this.fadeTimer);
    if (this.motionTweens) {
      this.motionTweens.forEach((tween) => {
        if (tween.scrollTrigger) tween.scrollTrigger.kill();
        tween.kill();
      });
    }
    $('body').removeClass('fadepage hash-domkino');
  }

  render() {
    return (
      <div className="case">
        <div className="case-content" id="case-domkino">
          <section className="domkino-hero">
            <img src="/cases/img/domkino/hero.webp" alt={copy.title} />
            <div className="domkino-hero__blinds" aria-hidden="true">
              {Array.from({ length: 14 }).map((_, index) => (
                <span style={{ '--blind-index': index }} key={index} />
              ))}
            </div>
          </section>

          <section className="domkino-about">
            <div className="domkino-about__main">
              <h1>{fixPrepositions(copy.title)}</h1>
              <dl>
                <div><dt>{'\u041a\u043b\u0438\u0435\u043d\u0442'}</dt><dd>{copy.client}</dd></div>
                <div><dt>{'\u0412\u0438\u0434\u044b \u0440\u0430\u0431\u043e\u0442'}</dt><dd>{copy.services}</dd></div>
              </dl>
            </div>
            <p>{fixPrepositions(copy.about)}</p>
          </section>

          <Poster name="logo-stage" alt="Логотип жилого комплекса Дом Кино" />
          <CopySection title={'\u041f\u043e\u0437\u0438\u0446\u0438\u043e\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435'}>{copy.positioning}</CopySection>
          <Poster name="positioning-cards" alt="Плакаты жилого комплекса Дом Кино" />
          <CopySection title={'\u0421\u0443\u043f\u0435\u0440-\u0437\u043d\u0430\u043a'}>{copy.sign}</CopySection>
          <Poster name="super-sign-grid" alt="Фирменный знак жилого комплекса Дом Кино" />
          <Poster name="super-sign-building" alt="Фирменный знак на архитектуре жилого комплекса Дом Кино" />
          <CopySection title={'\u041b\u043e\u0433\u043e\u0442\u0438\u043f'}>{copy.logo}</CopySection>
          <Poster name="logo-grid" alt="Логотип жилого комплекса Дом Кино" />
          <Poster name="editorial" alt="Фирменные материалы жилого комплекса Дом Кино" />

          <CaseFooterNew
            to="/projects/dune/"
            title={'\u0414\u044e\u043d\u0430'}
            img="/cases/img/dune/dune.webp"
            full={true}
          />
        </div>
        <HelmetSite title="Dom Kino" />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Domkino);
